import { execAdmin } from '@src/apis/reware/utils';
import type {
  AddToPricingImportMutation,
  AddToPricingImportMutationVariables,
} from '@src/types/__generated/rewareAdminTypes';

const gql = String.raw;

/**
 * Add pricing rules to an existing import session.
 * The pricingDiscountId must come from a prior call to startPricingImport.
 */
export const addToPricingImport = async ({
  partnerId,
  pricingDiscountId,
  rules,
}: AddToPricingImportMutationVariables) => {
  const query = gql`
    mutation addToPricingImport(
      $partnerId: Int!
      $pricingDiscountId: Int!
      $rules: [PricingRuleInput!]!
    ) {
      partner(id: $partnerId) {
        addToPricingImport(
          pricingDiscountId: $pricingDiscountId
          rules: $rules
        ) {
          created
          errors {
            index
            message
          }
        }
      }
    }
  `;

  const data = await execAdmin<
    AddToPricingImportMutationVariables,
    AddToPricingImportMutation
  >(query, { variables: { partnerId, pricingDiscountId, rules } });

  const result = data.partner?.addToPricingImport;
  if (!result) {
    throw new Error(
      `addToPricingImport: unexpected response — partner.addToPricingImport is ${result === null ? 'null' : 'undefined'} (partnerId=${partnerId}, pricingDiscountId=${pricingDiscountId})`
    );
  }

  return result;
};
